import { inject, Injectable, Injector, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';
import { BreakpointObserver } from '@angular/cdk/layout';
import { GLOBAL_BREAKPOINTS } from '@pc/common';

@Injectable({
  providedIn: 'root'
})
export class BreakpointObserverService {
  private breakpointObserver = inject(BreakpointObserver);

  public getSmallBreakpoint(injector: Injector): Signal<boolean> {
    const breakpoint = GLOBAL_BREAKPOINTS.MEDIUM + 'px';
    const $mediumBreakpoint = this.breakpointObserver
      .observe([`(max-width: ${breakpoint})`])
      .pipe(map((state) => state.matches));
    return toSignal($mediumBreakpoint, { injector }) as Signal<boolean>;
  }

  public getMediumBreakpoint(injector: Injector): Signal<boolean> {
    const breakpoint = GLOBAL_BREAKPOINTS.MEDIUM + 'px';
    const $mediumBreakpoint = this.breakpointObserver
      .observe([`(min-width: ${breakpoint})`])
      .pipe(map((state) => state.matches));
    return toSignal($mediumBreakpoint, { injector }) as Signal<boolean>;
  }

  public getMediumToLargeBreakpoint(injector: Injector): Signal<boolean> {
    const mediumBreakpoint = GLOBAL_BREAKPOINTS.MEDIUM + 'px';
    const xLargeBreakpoint = GLOBAL_BREAKPOINTS.XLARGE - 1 + 'px';
    const $mediumToXLargeBreakpoint = this.breakpointObserver
      .observe([`(min-width: ${mediumBreakpoint}) and (max-width: ${xLargeBreakpoint})`])
      .pipe(map((state) => state.matches));
    return toSignal($mediumToXLargeBreakpoint, { injector }) as Signal<boolean>;
  }

  public getLargeBreakpoint(injector: Injector): Signal<boolean> {
    const breakpoint = GLOBAL_BREAKPOINTS.LARGE + 'px';
    const $largeBreakpoint = this.breakpointObserver
      .observe([`(min-width: ${breakpoint})`])
      .pipe(map((state) => state.matches));
    return toSignal($largeBreakpoint, { injector }) as Signal<boolean>;
  }
  public getXLargeBreakpoint(injector: Injector): Signal<boolean> {
    const breakpoint = GLOBAL_BREAKPOINTS.XLARGE + 'px';
    const $xLargeBreakpoint = this.breakpointObserver
      .observe([`(min-width: ${breakpoint})`])
      .pipe(map((state) => state.matches));
    return toSignal($xLargeBreakpoint, { injector }) as Signal<boolean>;
  }
}
